import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {Offset} from '../../../../models/Offset';
import {Subscription} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {DomSanitizer} from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import * as toastr from 'toastr';
import {ChargesScartoService} from '../service-charges-scarto/charges-scarto.service';
import {ScartiConsuntivoChargesModel} from '../../../../models/ScartiConsuntivoChargesModel';
import * as FileSaver from 'file-saver';
import {MatDialog} from '@angular/material';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';

@Component({
  selector: 'app-filter-waste-charges',
  templateUrl: './filter-waste-charges.component.html',
  styleUrls: ['./filter-waste-charges.component.scss']
})
export class FilterWasteChargesComponent extends ProjectConstants implements OnInit, OnDestroy {

  regionCod: string;
  localCustomerCod: string;
  resourceUnitCod: string;
  designedServiceCod: string;
  contractTypeCod: string;
  providerCod: string;
  offset: Offset;
  fileName: string;
  filter: ScartiConsuntivoChargesModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;

  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/csv',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    }),
    responseType: 'application/csv'
  };

  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;

  @Input() reportSection?: boolean;
  @Input() numAnnoMeseData?: number;
  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private loaderService: LoaderService,
              private chargesScartoService: ChargesScartoService,
              private sanitizer: DomSanitizer,
              private dialog: MatDialog) {
    super();
    this.numAnnoMeseData = null;
    this.regionCod = null;
    this.localCustomerCod = null;
    this.resourceUnitCod = null;
    this.designedServiceCod = null;
    this.contractTypeCod = null;
    this.providerCod = null;
  }

  ngOnInit() {
    this.filter = new ScartiConsuntivoChargesModel();
    this.offset = new Offset(10, 0);
  }


  filterTable(): void {
    this.loaderService.display(true);
    this.getAllFilters();
    this.dataFiltered.emit(this.filter);
  }

  resetTable() {
    this.numAnnoFilterComponent.reset();
    this.localCustomerCod = null;
    this.regionCod = null;
    this.resourceUnitCod = null;
    this.contractTypeCod = null;
    this.designedServiceCod = null;
    this.providerCod = null;

    this.filterTable();
  }

  ngOnDestroy(): void {
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.chargesScartoService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.chargesScartoService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadTableXls() {
    this.loaderService.display(true);
    const filter: ScartiConsuntivoChargesModel = new ScartiConsuntivoChargesModel();
    this.getNameSubscribe = this.chargesScartoService.getNameGenerateXlsx(this.offset, filter)
      .subscribe(
        resultPage => {
              const currentDate = new Date();
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([resultPage], { type: this.EXCEL_TYPE }), 'charges_waste_' + currentDate + '.xlsx');
              } else {
                FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }), 'charges_waste_' + currentDate + '.xlsx');
              }
              toastr.success('XLS downloaded with success', 'Success');

              this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUMPTIVE_CHARGES_WASTE}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }    this.filter.localCustomerCod = this.localCustomerCod;
    this.filter.localCustomerCod = this.localCustomerCod ? this.localCustomerCod : '';
    this.filter.regionCod = this.regionCod ? this.regionCod : '';
    this.filter.resourcesUnitCod = this.resourceUnitCod ? this.resourceUnitCod : '';
    this.filter.contractCod = this.contractTypeCod ? this.contractTypeCod : '';
    this.filter.designedServiceCod = this.designedServiceCod ? this.designedServiceCod : '';
    this.filter.providerCod = this.providerCod ? this.providerCod : '';
    this.loaderService.display(false);
  }
}
